var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmployerExLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "#3B82F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9966 20.3082C39.9104 20.2715 37.8118 19.3769 25.3864 14.0791C25.1392 13.9736 24.8592 13.9736 24.612 14.0791L10.0019 20.3082C9.21793 20.6418 9.22548 21.7367 10.0019 22.0668C12.8402 23.2767 17.4801 25.2553 24.612 28.296C24.8577 28.4008 25.1377 28.402 25.3864 28.296C26.0636 28.0072 35.2915 24.0727 35.7134 23.893V34.0981C35.7134 34.6143 36.1166 35.0583 36.6408 35.0823C37.2 35.108 37.6613 34.6698 37.6613 34.125V23.5454C37.6613 23.3949 37.548 23.2677 37.3962 23.2485C35.568 23.0167 26.9462 21.9218 24.8744 21.6589C24.2751 21.5852 23.9017 20.9882 24.0593 20.4568C24.1828 20.008 24.6159 19.7221 25.0546 19.7518C25.0983 19.7543 38.9788 21.5167 38.9688 21.5154C39.2281 21.5483 39.4412 21.7117 39.5436 21.9332C39.6152 22.0881 39.7976 22.1591 39.9541 22.0869C40.2161 21.966 40.4434 21.8069 40.5469 21.4469C40.6798 20.9803 40.4394 20.4967 39.9966 20.3082Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9065 30.2156L16.2338 26.8574C16.0447 26.7746 15.8335 26.9147 15.8335 27.1229V30.4447C15.8335 33.5597 19.86 35.9999 25.0002 35.9999C30.1404 35.9999 34.1668 33.5597 34.1668 30.4447V27.1229C34.1668 26.9147 33.9556 26.7747 33.7665 26.8574L26.0933 30.2156C25.3966 30.5214 24.6038 30.5212 23.9065 30.2156Z",
    fill: "#EBF2FE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmployerExLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmployerExLogo.6898bd7f1a60a493612c872d5bb71dbe.svg";